export function setupProductRequestForm() {
    const form = document.querySelector('[data-action="product-request-form"]');

    if (form) {
        const productName = form.getAttribute('data-product-name');
        const productNumber = form.getAttribute('data-product-number');
        const productNameField = form.querySelector('#Productname');
        const productNumberField = form.querySelector('#Productnumber');

        if (productNameField) {
            productNameField.value = productName;
        }

        if (productNumberField) {
            productNumberField.value = productNumber;
        }
    }
}
